/**
 * Tous les montants transitent en **centimes entiers** entre le serveur et le
 * client. On ne fait jamais d'arithmétique métier sur des flottants d'euros :
 * un arrondi à 0,01 € près sur une commission finit par décaler un solde de
 * reversement, et un déposant qui compte ses sous le remarque.
 */
/** Convertit une saisie utilisateur (« 340 », « 12,50 », « 12.5 ») en centimes. */
export function centimesDepuisSaisie(saisie) {
    if (typeof saisie === 'number') {
        return Number.isFinite(saisie) ? Math.round(saisie * 100) : null;
    }
    const nettoye = saisie.trim().replace(/\s/g, '').replace(',', '.');
    if (nettoye === '' || !/^\d*\.?\d*$/.test(nettoye))
        return null;
    const valeur = Number.parseFloat(nettoye);
    return Number.isFinite(valeur) ? Math.round(valeur * 100) : null;
}
/** Formate des centimes en euros à la française — « 1 240 € », « 12,50 € ». */
export function eur(centimes, options = {}) {
    const avecDecimales = options.decimales ?? centimes % 100 !== 0;
    return (centimes / 100).toLocaleString('fr-FR', {
        minimumFractionDigits: avecDecimales ? 2 : 0,
        maximumFractionDigits: avecDecimales ? 2 : 0,
    }) + ' €';
}
/** Formate des centimes sans le symbole — pour les champs de saisie. */
export function euroBrut(centimes) {
    return (centimes / 100).toFixed(2).replace('.', ',');
}
//# sourceMappingURL=argent.js.map